import { useEffect, useRef } from 'react'
import { HEYIMMO_WIDGET_URL } from '../../../config'
import './HeyImmo.css'
import { getLogger } from '../../../services/logger/logger'
import { isWebView } from '../../../utils/navigation'

const SCRIPT_ID = 'heyimmo-widget-script'
const logger = getLogger('HeyImmo')

/**
 * HeyImmo ChatBot widget component
 * Loads the widget script and provides the mount point
 */
export const HeyImmo = () => {
  const loadAttempted = useRef(false)
  const isWebViewContext = isWebView()

  useEffect(() => {
    if (isWebViewContext || !HEYIMMO_WIDGET_URL || loadAttempted.current) {
      return
    }

    loadAttempted.current = true

    // Check if script already exists
    if (document.getElementById(SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = HEYIMMO_WIDGET_URL
    script.async = true

    script.onerror = () => {
      logger.warn('Failed to load HeyImmo widget script', { url: HEYIMMO_WIDGET_URL })
    }

    document.body.appendChild(script)
  }, [isWebViewContext])

  return isWebViewContext ? null : <div id='ai-chat-bot' data-testid='ai-chat-bot' />
}
